import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import './i18n';
import Logo2 from './assets/Logo2.png';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  // Fail fast — the previous Logto setup did the same. Silent fallbacks
  // hid configuration bugs in CI before.
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required (set in .env.local for dev or Vercel env vars for prod).');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey}
      // Same Clerk instance as the Student + Platform-Admin apps, but
      // School-Admin owns its own sign-in URL. School admins are
      // provisioned through the school admin invite flow which JIT-creates
      // a User row with role=SCHOOL_ADMIN on first Clerk sign-in.
      signInUrl="/signin"
      signInFallbackRedirectUrl="/dashboard"
      afterSignOutUrl="/signin"
      // Instance-wide branding. Without this, every Clerk-rendered surface
      // OTHER than <SignIn> (the <UserProfile> panel, its "Verification
      // required" modals, the user button) falls back to the logo stored on
      // the Clerk instance — which is the pre-rebrand mark. Setting it here
      // covers them all; SignIn hides its own logoBox because that page
      // already renders the wordmark above the card.
      appearance={{ layout: { logoImageUrl: Logo2, logoLinkUrl: '/dashboard' } }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
